export default {
    home_page_title: "Hesap",
    security_page_title: "Güvenlik Merkezi",
    security_setting_page_title: "Güvenlik Merkezi",
    security_phone_label: "Telefon",
    security_email_label: "E-posta",
    security_question_label: "Güvenlik Sorusu",
    security_unset_text: "Ayarlanmadı",
    security_setted_text: "Ayarlandı",
    security_question_options: [
        "Annenin Adı ?",
        "Eşinin doğum tarihi?",
        "Babanın adı?",
        "Okul(İş) kodun?",
        "En yakın çocukluk arkadaşının ismi?",
        "Seni en çok etkileyen insan?"
    ],
    password_lost_page_title: "Şifremi unuttum",
    password_reset_page_title: "Şifre sıfırla",
    password_lost_account_placeholder: "Unuttuğunuz şifrenin hesabını girin!",
    empty_lost_account_tips: "Kullanıcı adı boş bırakılamaz",
    iscorrect_lost_account_tips: "Kullancı yok",
    password_reset_new_placeholder: "Yeni Şifre",
    password_reset_confirm_placeholder: "Yeni şifreyi onayla",
    password_verify_page_title: "Kimlik Doğrulaması",
    phone_verify_page_title: "Kimlik Doğrulaması",
    email_verify_page_title: "Kimlik Doğrulaması",
    question_verify_page_title: "Kimlik Doğrulaması",
    phone_reset_page_title: "Telefon",
    email_reset_page_title: "E-posta",
    question_reset_page_title: "Güvenlik Sorusu",
    phone_binding_text: "Bağlı Telefon Numaranız",
    email_binding_text: "Bağlı Posta Kutunuz",
    verification_code_text: "Onay Kodu",
    resend_text: "Tekrar gönder:",
    empty_phone_number_tips: "Cep nu. girin.",
    iscorrect_phone_number_tips: "Lütfen geçerli bir tel nu. formatı girin",
    empty_verification_code_tips: "Onay kodunu girin.",
    iscorrect_verification_code_tips: "Doğrulama kodu hatalı",
    password_placeholder: "Şifre",
    empty_password_tips: "Şifre giriniz",
    iscorrect_password_tips: "Hatalı Şifre",
    mismatched_rule_password_tips: "Şifre &amp ve # ve boşluk içeremez",
    different_confirm_password_tips: "Şifreler eşleşmiyor",
    empty_email_tips: "Lütfen Posta Kutusuna Giriniz",
    iscorrect_email_tips: "Posta Kutusu Hatalı",
    answer_placeholder: "Cevapla",
    empty_question_tips: "Soru seç",
    empty_answer_tips: "Yanıt,",
    iscorrect_answer_tips: "Yanıt yanlış",
    next_step_text: "Sonraki",
    submit_text: "Gönder",
    submit_success_tips: "Başarılı",
    submit_error_tips: "Operasyon başarısız oldu, lütfen tekrar deneyin",
    get_data_fail_tips: "Bağlantı problemi, lütfen tekrar deneyiniz",
    use_other_verification_type_text: "Diğer Doğrulama Yöntemleri",
    custom_support_notice:
        "BHesapta henüz bir şifre ayarlanmamış. Bilgisayarınızdan aşağıdaki bağlantıyı açarak başvurabilirsiniz:" +
        process.env.VUE_APP_ORIGIN_PROFILE
};
